import ClaimScreen from './ClaimScreen';

export default ClaimScreen;
